module.exports = __webpack_public_path__ + "img/flexible.ef127585.jpg";